import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  Input,
  OnChanges,
  SimpleChanges,
  inject
} from '@angular/core';
import { GetImageWithGidService } from '@coin/shared/auth/data-access';
import { take } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LegalEntityManagement } from '../../../api/generated';

@Component({
  selector: 'cosmos-manager-preview',
  templateUrl: './manager-preview.component.html',
  styleUrls: ['./manager-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ManagerPreviewComponent implements OnChanges {
  private imageService = inject(GetImageWithGidService);
  private cdr = inject(ChangeDetectorRef);
  private destroyRef = inject(DestroyRef);

  @Input() manager: LegalEntityManagement;
  @Input() position: string;

  public userImageSrc: string;

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.manager && changes.manager.previousValue?.gid !== changes.manager.currentValue?.gid) {
      this.loadUserImage();
    }
  }

  private loadUserImage(): void {
    this.userImageSrc = undefined;

    if (this.manager) {
      this.imageService
        .getImageWithStore(this.manager.gid)
        .pipe(take(1))
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(imgSrc => {
          this.userImageSrc = imgSrc;
          this.cdr.detectChanges();
        });
    }
  }
}
